import React from 'react';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';

import { useFileManagerContext } from 'modules/FileManagerV2/context/FileManagerContext';
import { queryKeys } from 'hooks/config/queryClient';
import { useQueryClient } from '@tanstack/react-query';

function ViewChanger() {
  const {
    currentView,
    setCurrentView,
    fileManagerFilters,
    getFiles,
    pageLimit,
    isGlobalFileManager,
    caseDetails,
    isClientFileManager,
    query,
  } = useFileManagerContext();

  const queryClient = useQueryClient();

  const caseId = isGlobalFileManager || isClientFileManager ? fileManagerFilters?.case?.id || '' : caseDetails?.case_id;

  const handleView = (view) => {
    setCurrentView(view);
    queryClient.invalidateQueries({ queryKey: queryKeys.fileManager.list(caseId) });
  };

  return (
    <div className="d-flex align-items-center justify-content-end gap-2 change-view ms-lg-2">
      <Button onClick={() => handleView('list')} className={`list-view ${currentView === 'list' ? 'highlight' : ''}`}>
        <i className="icon-List-view"></i>
        <Tooltip content="List view" position="top" target=".list-view" showDelay={500} />
      </Button>

      <Button onClick={() => handleView('grid')} className={`grid-view ${currentView === 'grid' ? 'highlight' : ''}`}>
        <Tooltip content="Grid view" position="top" target=".grid-view" showDelay={500} />
        <i className="icon-grid-view"></i>
      </Button>
    </div>
  );
}

export default ViewChanger;
